// extracted by mini-css-extract-plugin
export default {"heading":"EstimatedValuePanelHeading_heading__xnCTF","forceNoWrap":"EstimatedValuePanelHeading_forceNoWrap__s2OeF"};